import { MdKeyboardArrowRight } from "react-icons/md"
import { useContext, useEffect, useState } from "react"
import { AccountContext } from "../../contexts/AccountContexts"
import { SideActionButton } from "../../components/TicketComponents"
import { FaUserPlus } from "react-icons/fa6"
import { PageHeader } from "../../components/HeaderComponents"
import { useTranslation } from "react-i18next"
import { CreateNewDevModal, DevDeleteModal, DevDisableModal, DevDisperseTicketsModal, DevEditModal, DevEditPermissionsModal, DevEnableModal, DevTable, PasswordChangeModal } from "../../components/DeveloperComponents"
import { BreadCrumbsGeneral } from "../../components/NavigationComponents"
import { PermissionContext } from "../../contexts/PermissionContexts"
import { useNavigate } from "react-router-dom"
import { requestDevsActiveTicketNumbers } from "../../requests/users_requests"
import { ContentContext } from "../../contexts/ContentContext"



export const UsersPage = () => {
    const { t } = useTranslation('common')
    const { devs, getDevs } = useContext(AccountContext)
    const { permissions, hasPermission } = useContext(PermissionContext)
    const { openErrorModal } = useContext(ContentContext)
    const [selectedDev, setSelectedDev] = useState(null)
    const [activeTicketNumbers, setActiveTicketNumbers] = useState(null)

    const navigator = useNavigate()

    useEffect(() => {
        getDevs()
    }, [])

    useEffect(() => {
        if (devs) {
            let devIds = []
            let devValues = Object.values(devs)
            for (let i = 0; i < devValues.length; i++) {
                let devId = devValues[i].id
                devIds.push(devId)
            }
            requestDevsActiveTicketNumbers({ devIds: devIds }).
                then((data) => {
                    setActiveTicketNumbers(data.devs_active_ticket_numbers)
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(error)
                })
        }
    }, [devs])

    const handleCreateNewUser = () => {
        document.getElementById('create-new-dev-modal').showModal()
    }

    const breadCrumbs = [
        {
            link: "/admin/dashboard",
            name: t("Home")
        },
        {
            link: null,
            name: t("Users")
        }
    ]

    useEffect(() => {
        if (permissions.length > 0 && !hasPermission("users:view")) {
            navigator("/admin/dashboard")
        }
    }, [permissions])

    if (!hasPermission("users:view")) {
        return <></>
    }

    return (
        <>
            <PasswordChangeModal selectedDev={selectedDev} setSelectedDev={setSelectedDev} />
            <DevDisableModal selectedDev={selectedDev} setSelectedDev={setSelectedDev} />
            <DevEnableModal selectedDev={selectedDev} setSelectedDev={setSelectedDev} />
            <DevDeleteModal selectedDev={selectedDev} setSelectedDev={setSelectedDev} />
            <DevEditModal selectedDev={selectedDev} setSelectedDev={setSelectedDev} />
            {
                hasPermission("users:set_permissions") &&
                <DevEditPermissionsModal selectedDev={selectedDev} setSelectedDev={setSelectedDev} />
            }
            <DevDisperseTicketsModal selectedDev={selectedDev} setSelectedDev={setSelectedDev} />
            <CreateNewDevModal />
            <div className="flex flex-col justify-start items-center w-full py-2 gap-5 pb-10 px-4 h-full">
                <PageHeader pageTitle={t("Users")} />
                <div className="w-full">
                    <h1 className="text-xl font-semibold">{t("Users")}</h1>
                    <BreadCrumbsGeneral elements={breadCrumbs} />
                </div>
                <div className="flex flex-col w-full bg-white dark:bg-gray-700  rounded-xl shadow-lg gap-[1px] py-5 h-full">
                    {
                        hasPermission("users:create") &&
                        <div className="flex gap-2 w-full justify-end px-3">
                            <SideActionButton callback={handleCreateNewUser} title={t("Create new user")} content={<FaUserPlus size={18} />} />
                        </div>
                    }
                    <DevTable data={Object.values(devs)} selectedDev={selectedDev} setSelectedDev={setSelectedDev} activeTicketNumbers={activeTicketNumbers} />
                </div>
            </div>
        </>
    )
}